// extracted by mini-css-extract-plugin
export default {"warningIcon":"OrganizationDrawer_warningIcon__YKmIm"};